import React, { FC } from 'react';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

type AdditionalSelectFieldProps = {
  label: string;
  value: string | null | undefined;
  options: string[];
  disabled: boolean;
  minWidth?: number;
  onChange: (event: SelectChangeEvent<string>) => void;
  onClear: () => void;
};

export const AdditionalSelectField: FC<AdditionalSelectFieldProps> = ({
  label,
  value,
  options,
  disabled,
  minWidth = 200,
  onChange,
  onClear,
}) => (
  <FormControl variant="standard" sx={{ minWidth }}>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value ?? ''}
      disabled={disabled}
      onChange={onChange}
      label={label}
      endAdornment={
        value ? (
          <InputAdornment
            position="end"
            sx={{ position: 'absolute', right: 20 }}
          >
            <IconButton size="small" onClick={onClear} edge="end">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null
      }
    >
      {options.filter(Boolean).map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
